const messages = {
  // ================================================================
  // ACTIONS
  reset: 'Limpiar',
  save: 'Guardar',
  update: 'Actualizar',
  edit: 'Editar',
  delete: 'Eliminar',
  cancel: 'Cancelar',
  create: 'Crear',
  search: 'Buscar',
  accept: 'Aceptar',
  add: 'Agregar',
  login: 'Acceder',
  access: 'Acceder',
  logout: 'Salir',
  recover: 'Recuperar',
  finalize: 'Cerrar y enviar',
  send: 'Enviar',
  invite: 'Invitar',
  close: 'Cerrar',
  reopen: 'Reabrir',
  // custom
  upload: 'Subir {field}',
  change: 'Cambiar {field}',
  select: 'Seleccionar {field}',
  // ================================================================
  // MODELS
  match: 'Debate | Debates',
  language: 'Idioma | Idiomas',
  country: 'País | Paises',
  province: 'Provincia | Provincias',
  town: 'Ciudad | Ciudades',
  category: 'Categoría | Categorías',
  entity: 'Entidad | Entidades',
  team: 'Equipo | Equipos',
  user: 'Usuario | Usuarios',
  act: 'Acta | Actas',
  aspect: 'Aspecto | Aspectos',
  stadium: 'Centro | Centros',
  pitch: 'Aula | Aulas',
  role: 'Rol | Roles',
  tournament: 'Torneo | Torneos',
  phase: 'Fase | Fases',
  group: 'Sala | Sales',
  advertising: 'Anunci | Anuncis',
  course: 'Curs | Cursos',
  event: 'Evento | Eventos',
  // list name
  rolList: 'Lista de Roles',
  items: 'Elementos',
  // ================================================================
  new: 'Nuevo',
  // ================================================================
  // TITLES / LABELS
  // global
  dashboard: 'Dashboard',
  admin: 'Administrador',
  apps: 'Aplicaciones',
  management: 'Gestión',
  config: 'Configuración',
  state: 'Estado',
  chronometer: 'Cronómetro debate',
  simpleChronometer: 'Cronómetro simple',
  yes: 'Si',
  no: 'no',
  previous: 'Anterior',
  next: 'Siguiente',
  none: 'Ninguno',
  termsAndConditions: 'Términos y condiciones',
  termsOfUse: 'Condiciones de uso',
  newModel: 'Nuevo {field}',
  newAModel: 'Nueva {field}',
  updateModel: 'Actualizar {field}',
  deleteModel: 'Eliminar {field}',
  addField: 'Agregar {field}',
  information: 'Información',
  generalInformation: 'Información General',
  score: 'Score',
  typeScore: 'Tipo de puntuación',
  untilScore: 'Límite de la puntuación',
  value: 'Valor',
  option: 'Opcion',
  options: 'Opcions',
  content: 'contingut',
  confirmDelete: 'Confirme que desea eliminar el {field} <b>{name}</b>.',
  confirmADelete: 'Confirme que desea eliminar la {field} <b>{name}</b>.',
  confirmClone: 'Confirme que desea duplicar el {field}',
  titleFile: 'Subir Archivo',
  // matches
  result: 'Resultado',
  faults: 'Penalizaciones',
  total: 'Total',
  matchResult: 'Resultado del Debate',
  homeTeamTitle: 'a favor',
  visitorTeamTitle: 'en contra',
  homeTeamResult: 'Resultado equipo a favor',
  visitorTeamResult: 'Resultado equipo en contra',
  confirmDeleteMatchFromGroup:
    'Confirmeu que voleu eliminar el debat de la sala seleccionada.',
  addEvent: 'Agregar evento',
  // users / profiles
  userInformation: 'Información del Usuario',
  personalData: 'Datos personales',
  accountData: 'Datos de la cuenta',
  profile: 'Perfil',
  man: 'Hombre',
  woman: 'Mujer',
  noRole: 'Sin rol',
  // acts
  notFaultSystem: 'No hay sistema de faltas.',
  confirmation: 'Confirmación',
  confirmDeleteAct: 'Confirme que desea eliminar el acta.',
  addCategory: 'Agregar Categoría',
  addType: 'Agregar Tipo',
  categoryEmpty: 'No hay contenido en esta categoría.',
  mainData: 'Datos principales',
  categoryAssign: 'Asignación de categorias',
  aspectAssign: 'Asignación de aspectos',
  ifFaultSystem: '¿Sistema de faltas?',
  smallFaultValue: 'Valor falta leve',
  seriousFaultsValue: 'Valor falta grave',
  // aspects
  checkbox: 'Casilla 0 / 1',
  dropdown: 'Seleccionar',
  textbox: 'Campo Libre',
  // categories
  parentCategory: 'Categoría padre',
  newCategoryWithParent: 'Nueva categoría con parent predefinido',
  // entities
  client: 'Cliente',
  siteUrl: 'Url del sitio',
  defaultLanguage: 'Idioma por defecto',
  // roles
  description: 'Descripción',
  permissions: 'Permisos',
  // tournaments
  participant: 'Participante',
  participants: 'Participantes',
  table: 'Tabla',
  clasification: 'Clasificación',
  videos: 'Videos',
  isConfirmed: '¿Confirmado?',
  ifAccepted: '¿Aceptado?',
  ifInvitationSent: '¿Invitación enviada?',
  left: 'Quedan',
  ifShowResults: '¿Mostrar resultados?',
  ifRandomMatches: '¿Random Matches?',
  finished: 'Finalizado',
  complete: 'Completo',
  byUsers: 'Por usuarios',
  byTeams: 'Por equipos',
  position: 'Posición',
  points: 'Puntos',
  participantsQuantity: 'Cantidad de Participantes',
  dates: 'Fechas',
  openAct: 'Ver acta',
  duplicate: 'Duplicar',
  // phases
  ranking: 'Resultados',
  winners: 'Ganadores',
  // groups
  noGroup: 'Sin Salas',
  // ================================================================
  // FIELDS
  // reset password
  newPassword: 'Nueva Contraseña ',
  repeatPassword: 'Repita su Contraseña ',
  // global
  createdAt: 'Fecha de creación',
  updatedAt: 'Ultima actualización',
  createdBy: 'Creado por',
  updatedBy: 'Actualizado por',
  actions: 'Acciones',
  active: 'Activo',
  name: 'Nombre',
  type: 'Tipo',
  types: {
    tournament: 'Torneo',
    league: 'Liga',
    friendly: 'Amistoso',
    user: 'Usuario'
  },
  date: 'Fecha',
  time: 'Hora',
  location: 'Lugar',
  order: 'Orden',
  // dashboard
  notActive: 'Inactivo',
  deleted: 'Eliminado',
  // usuarios
  username: 'Usuario',
  validated: 'Validado',
  lastname: 'Primer Apellido',
  lastname2: 'Segundo Apellido',
  email: 'Correo Electrónico',
  password: 'Contraseña',
  sex: 'Sexo',
  birthdayDate: 'Fecha de Nacimiento',
  address: 'Dirección',
  cp: 'Código Postal',
  phone: 'Teléfono',
  userImage: 'Imagen de Avatar',
  image: 'Imagen',
  lastAccess: 'Último acceso',
  // matches
  finalized: 'Finalizado',
  all: 'Todos',
  notFinalized: 'No Finalizado',
  judges: 'Jueces',
  homeTeam: 'Equipo a favor',
  visitorTeam: 'Equipo en contra',
  video: 'Video',
  youtubeVideo: 'Video Youtube',
  warnings: 'Avisos',
  smallFaults: 'Faltas leves',
  seriousFaults: 'Faltas graves',
  // eventsCreated
  additionalContent: 'Contenido adicional',
  minute: 'Minuto',
  second: 'Segundo',
  // languages
  iso: 'ISO',
  // tournaments
  startAt: 'Fecha de inicio',
  endAt: 'Fecha de fin',
  confirmed: 'Confirmado',
  accepted: 'Aceptado',
  usersTeams: 'Usuarios por equipos',
  showRanking: 'Mostrar Ranking',
  openInscription: 'Inscripciónes abiertas',
  numberParticipants: 'Número máximo de {field}',
  randomMatches: 'Debates aleatorios',
  hours: 'Horas',
  inscription: 'Inscripción',
  // phases
  typePlayOff: 'Tipo de clasificación',
  toClass: 'A clasificar',
  matchesByParticipant: 'Debates por participante',
  // stats
  stats: 'Estadísticas',
  actStats: 'Estadísticas de Acta',
  tournamentStats: 'Estadísticas de Torneo',
  userStats: 'Estadísticas de Usuarios',
  stanceResult: 'Distribución de Posturas',
  wonLostResult: 'Datos Cualitativos del Equipo',
  average: 'Media',
  won: 'Ganados',
  lost: 'Perdidos',
  // Anuncios (advertising)
  chronometerSimple: 'Cronòmetre simple',
  chronometerMatch: 'Cronòmetre debat',
  boardTournament: 'Taula torneig',
  leftRankingTournament: 'Esquerra classificació torneig',
  rightRankingTournament: 'Dreta classificació torneig',
  adsImage: "Imatge de l'anunci",
  width: 'Amplada',
  height: 'Alçada',
  adsLocation: 'Ubicació',
  // Chronometers
  categoryAspectBase1: 'Exp. Inicial',
  categoryAspectBase2: 'Ref. Argumentativa',
  categoryAspectBase3: 'Ref. Dialéctica',
  categoryAspectBase4: 'Ref. Dialética 2',
  categoryAspectBase5: 'Ref.Dialéctica 3',
  categoryAspectBase6: 'Ref. Dialéctica 4',
  categoryAspectBase7: 'Conclusión',
  // ================================================================
  // ERRORS
  error: {
    // global
    userNotFound: 'Usuario no encontrado.',
    empty: 'El campo no puede estar vacío.',
    invalidEmail: 'Correo electrónico inválido.',
    passwordDoNotMatch: 'Las contraseñas ingresadas no coinciden.',
    min: 'El valor debe tener mínimo 6 caracteres.',
    minNumber: 'El valor debe ser mayor o igual a {field}.',
    maxNumber: 'El valor debe ser menor o igual a {field}.',
    required: 'El campo {field} es requerido.',
    resultsNotFound: 'No se encontraron resultados.',
    modelNotFound: 'No se ha encontrado el {field}.',
    modelANotFound: 'No se ha encontrado la {field}.',
    nameSpanish: 'El campo Nombre es requerido en Español',
    // matches
    equalTeams: 'El equipo a favor debe ser distinto al equipo en contra.',
    invalidYoutubeVideo: 'El enlace no es un video válido de Youtube',
    // users
    rolesIncomplete: 'No se han elegido todos los roles.',
    roleError: 'Error en el rol: ',
    // tournaments
    invalidType: 'El tipo elegido es incorrecto.',
    oneRequired: 'Debe seleccionar al menos un {field}.',
    oneARequired: 'Debe seleccionar al menos una {field}.',
    invalidParticipantsRange:
      'El número de participantes debe estar entre 1 y 100.',
    emptyStadium: 'Cuidado. El centro <b>{field}</b> no tiene aulas asignadas.',
    emptyStadiums: 'Los centros elegidos no tienen aulas.',
    // phases
    orderInUse: 'Ya existe una fase con orden {field}.',
    // advertising
    // advertising
    invalidMinImage: "L'{field} de la imatge no és correcte",
    // api responses
    timeout: 'Tiempo de respuesta excedido.',
    notConnection: 'Conexión de internet no disponible.',
    messageNotDefined: 'Error sin mensaje definido.',
    sessionExpired: 'La sesión ha expirado, por favor ingrese nuevamente.',

    validationError: 'Error en validació, revisar formulari.'
  },
  // ================================================================
  // MESSAGES
  messages: {
    // global
    loading: 'Cargando...',
    searching: 'Buscando...',
    fieldRequired: 'Indica campo requerido.',
    // reset password
    lostPassword: 'Introduzca el correo electrónico de su cuenta de usuario.',
    setNewPassword: 'Introduzca su nueva contraseña.',
    forgotPassword: '¿Has olvidado tu contraseña?',
    // matches
    resultModified: 'Resultado modificado manualmente.',
    judgeResults: 'Puntuación del juez seleccionado.'
  }
}

export default messages
